import type { UseFormReturn } from "react-hook-form";
import type { FormSubmit } from "@shared-kernel/primary/shared/api-errors/action-form";
import { PasswordForm } from "../shared/password-form/password-form.content";
import type { FormInputs } from "../shared/password-form/form-validation/user-password.schema";

interface Props {
  form: UseFormReturn<FormInputs>;
  onSubmit: FormSubmit;
  email: string;
}

export const PasswordUpdateContent = ({ form, onSubmit, email }: Props) => {
  return (
    <PasswordForm
      title="Veuillez saisir votre nouveau mot de passe pour le compte suivant:"
      form={form}
      onSubmit={onSubmit}
      email={email}
    />
  );
};
